import React from "react"
import { Link } from "gatsby"
import { renderHTML } from "../../agility/utils"
import { PressReleaseDetailsContainer, Wrapper } from "./styles"
import { BsArrowLeft } from "react-icons/bs"

const PressReleaseDetails = ({ dynamicPageItem }) => {
  return (
    <PressReleaseDetailsContainer>
      <Wrapper>
        <Link to="/press">
          <BsArrowLeft />
        </Link>
        <h1>Release</h1>
        <h3 className="press-release-title">
          {dynamicPageItem.customFields.title}
        </h3>
        {dynamicPageItem.customFields.content && (
          <div
            dangerouslySetInnerHTML={renderHTML(
              dynamicPageItem.customFields.content
            )}
          />
        )}
      </Wrapper>
    </PressReleaseDetailsContainer>
  )
}

export default PressReleaseDetails
